export default __webpack_public_path__ + "static/media/arboles_sembrados.4c73a19d.png";